import type { RootState } from '@debbie/cortex/dist/reducer.js'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

interface Props {
  error: string
}

export const Error = <A extends Props>(props: A) => {
  console.trace(props.error)
  const lang = useSelector((s: RootState) => s.lang)
  return (
    <Wrapper>
      <h1>
        {lang.misc.error}: {props.error.toString()}
      </h1>
    </Wrapper>
  )
}

export default Error
